import i from "../token.js";
function s(t, e, o) {
  this.src = t, this.env = o, this.tokens = [], this.inlineMode = !1, this.md = e;
}
s.prototype.Token = i;
export {
  s as default
};
